import type { ReactElement } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { CalendarCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { AgendarTarefaPopover } from './AgendarTarefaPopover';
import { useAcaoAtivacao } from '@/hooks/useAtivacaoLinhas';

/** ⛔ O RÓTULO TEM QUE SER VERDADE ONDE ELE ESTÁ (Douglas 23/09/2026).
 * O botão dizia "Agendar retorno / liberar próximo" em toda parte. "Liberar
 * próximo" é a FILA da triagem: no Painel CRM não existe fila, e o backend
 * (`agendarRetornoEsim`) só cria a tarefa e marca o retorno na linha — não
 * libera coisa nenhuma ali. Quem tem fila passa `liberaFila`. */
export function AgendarRetornoEsim({ linhaId, pedidoId, revisao, retornoEm, onSalvo, trigger, clienteNome, liberaFila }: {
  linhaId: string; pedidoId: string; revisao: number; retornoEm?: string | null; onSalvo?: () => void;
  trigger?: ReactElement; clienteNome?: string; liberaFila?: boolean;
}) {
  const acao = useAcaoAtivacao(pedidoId);
  const qc = useQueryClient();
  if (retornoEm) return <a className={trigger ? trigger.props.className : 'text-[11px] underline text-primary'} href="/whatsapp-inbox?tarefas=1" target="_blank" rel="noopener noreferrer" aria-label="Ver tarefa de retorno" title={`Retorno agendado: ${new Date(retornoEm).toLocaleString('pt-BR')}. A linha continua pendente.`}>{trigger ? <CalendarCheck /> : `Retorno: ${new Date(retornoEm).toLocaleString('pt-BR')} · Ver tarefa`}</a>;
  return <AgendarTarefaPopover clienteNome={clienteNome} trigger={trigger || <Button type="button" variant="outline" size="sm" className="h-[29px] px-2 text-[11px]">{liberaFila ? 'Agendar retorno / liberar próximo' : 'Agendar retorno'}</Button>}
    retornoEsim={{ liberaFila, salvar: async ({ motivo, quando }) => {
      await acao.mutateAsync({ path: `linhas/${linhaId}/agendar-retorno`, body: { revisao, motivo, quando } });
      void qc.invalidateQueries({ queryKey: ['tarefas'] });
      void qc.invalidateQueries({ queryKey: ['timeline-unificada'] });
      onSalvo?.();
    } }} />;
}
